// extracted by mini-css-extract-plugin
export var actionButton = "_k9-t";
export var buttonContainer = "_k9-0";
export var buttonContainer2 = "_k9-1";
export var buttonSection = "_k9-2";
export var details = "_k9-3";
export var dropdownItem = "_k9-5";
export var dropdownItemsContainer = "_k9-4";
export var fileInput = "_k9-r";
export var headerButton = "_k9-6";
export var icon = "_k9-7";
export var input = "_k9-8";
export var macroListItem = "_k9-9";
export var mainContent = "_k9-a";
export var microText = "_k9-b";
export var modal = "_k9-w";
export var optionsButton = "_k9-c";
export var paperclip = "_k9-s";
export var pillContent = "_k9-d";
export var preview = "_k9-e";
export var preview2 = "_k9-f";
export var quillEditor = "_k9-q";
export var selectedMacro = "_k9-g";
export var sidebar = "_k9-h";
export var sidebarHeader = "_k9-j";
export var sidebarList = "_k9-i";
export var sidebarListItem = "_k9-k";
export var sidebarSearch = "_k9-l";
export var snoozeDurationWrapper = "_k9-v";
export var statusPillContainer = "_k9-m";
export var tagsContainer = "_k9-n";
export var unselectedMacro = "_k9-o";
export var variable = "_k9-u";
export var wrapper = "_k9-p";